var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { spliceSelectSQLByConditions } from '../_utils/selectSQL';
import { spliceDataFormat } from '../_utils/format';
export default function (_a) {
    var _this = this;
    var _b;
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    if (!data.selector) {
        return;
    }
    var isEdit = (_b = env.runtime) === null || _b === void 0 ? void 0 : _b.debug;
    var baseParams = {
        params: {},
        fields: data.selector.fields || [],
        conditions: data.selector.conditions || [],
        entities: data.selector.entities || [],
        limit: data.selector.limit,
        showPager: false,
        selectCount: false,
        orders: data.selector.orders,
        pageNum: data.selector.pageNum,
        isEdit: isEdit,
    };
    var select = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var sql, res, rows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sql = (spliceSelectSQLByConditions(params) || [])[0];
                    env.collect('查询数据 sql: ', sql);
                    return [4 /*yield*/, env.executeSql(sql)];
                case 1:
                    res = _a.sent();
                    env.collect('查询数据 res: ', res);
                    rows = res.rows;
                    rows = Array.from(rows || []);
                    spliceDataFormat(params.fields || [], params.entities, rows);
                    return [2 /*return*/, rows];
            }
        });
    }); };
    if (data.autoRun) {
        select(baseParams)
            .then(function (data) { return outputs['rtn'](data); })
            .catch(function (ex) {
            isEdit ? console.error('执行SQL发生错误, ', ex) : undefined;
            onError("\u6267\u884CSQL\u53D1\u751F\u9519\u8BEF, ".concat(ex === null || ex === void 0 ? void 0 : ex.message));
        });
    }
    inputs['params'](function (val) {
        select(__assign(__assign({}, baseParams), { params: val, orders: (val.orders && Array.isArray(val.orders)) ? val.orders : baseParams.orders }))
            .then(function (data) { return outputs['rtn'](data); })
            .catch(function (ex) {
            isEdit ? console.error('执行SQL发生错误, ', ex) : undefined;
            onError("\u6267\u884CSQL\u53D1\u751F\u9519\u8BEF, ".concat(ex === null || ex === void 0 ? void 0 : ex.message));
        });
    });
}
